import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ChannelConversionStatistics" }
const _hoisted_2 = { class: "itemModal" }
const _hoisted_3 = { style: {"display":"flex","align-items":"center","gap":"10px"} }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import dayjs from 'dayjs'
import {downloadData, getListData, getPageListData} from "@/service/main/system";
import {usePageModal} from "@/hooks/usePageModal";
import {modalConfig} from "./config/modal.config";
import {ref, watch} from "vue";
import {ElLoading} from "element-plus";
import {summaryTableConfig} from "./config/summary.config";
import LfTable from "@/components/LfTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelConversionStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()

const modalTitle = ref('更换老师')

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channelName')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const queryParam = {
  month: dayjs().format('YYYY-MM'),
  cfddFlag: false,
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const month = ref(dayjs().format('YYYY-MM'));
const listDialogVisible = ref(false)
const listDialogTitle = ref('')
const listTableTitle = ref('');
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const pageInfo = ref({pageNo: 1, pageSize: 100})
const handleConversionStatistics = () => {
  listDialogVisible.value = true;
  listDialogTitle.value = '渠道资源转化汇总'
  listTableTitle.value = '列表数据'
  getListPageData();
}

const getListPageData = async () => {
  const condition = {
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize,
    month: month.value
  }
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '查询数据中...',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  await getPageListData(
    '/main/channelConversionStatistics/conversionSummary',
    condition,
  ).then((res) => {
    loadingInstance.close()
    dataList.value = res.list
    dataCount.value = Number(res.total)
  })
}

const dialogClose = () => {
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 100;
  dataCount.value = 0;
  month.value = dayjs().format('YYYY-MM')
}
watch(pageInfo, () => getListPageData())

const downloadSummary = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  await downloadData(
    '/main/channelConversionStatistics/downloadSummary', {},
    'blob'
  ).then((res) => {
    loadingInstance.close()
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = '渠道资源转化汇总统计.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const resetCb = () => {
  return queryParam
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal()

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "channelConversionStatistics",
      downFilename: "渠道资源转化统计.xlsx",
      onEditBtnClick: _unref(handleEditData),
      onDownBtnClick: _unref(handleDownBtnClick),
      onConversionSummaryClick: handleConversionStatistics,
      onSortChange: handleSortChange
    }, {
      repeatRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
      ]),
      deleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
      ]),
      developRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.developRate) + "%", 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onEditBtnClick", "onDownBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dialog, {
        title: listDialogTitle.value,
        modelValue: listDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((listDialogVisible).value = $event)),
        width: "70%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_date_picker, {
              modelValue: month.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((month).value = $event)),
              type: "month",
              placeholder: "请选择月份",
              "value-format": "YYYY-MM"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: getListPageData
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadSummary
            }, {
              default: _withCtx(() => [
                _createTextVNode("下载")
              ]),
              _: 1
            })
          ]),
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: listTableTitle.value
          }, _unref(summaryTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo).value = $event))
          }), {
            repeatRate: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
            ]),
            deleteRate: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
            ]),
            developRate: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.developRate) + "%", 1)
            ]),
            _: 1
          }, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "channelConversionStatistics",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})